import {db} from '../db';
import PlayTesterUser from './PlayTesterUser';


/*Retrieve total number of playtesters currently registered*/
async function getTotalPlaytesters() {
    try {
        const querySnapshot = await db.collection("PlayTester").get();
        return querySnapshot.size; 
    } catch (error) {
        console.error("Error fetching total playtesters:", error);
        return 0; 
    }
}

/*Retrieve total number of Developers currently registered*/
async function getTotalDevs() {
    try {
        const querySnapshot = await db.collection("User").where("userType", "==", "developer").get();
        return querySnapshot.size;
    } catch (error) {
        console.error("Error fetching total developers:", error);
        return 0; 
    }
}

/*Retrieve total number of playtesters that have logged in in the past 1 hour*/
async function getOnlineTesters() {
    try {
        const oneHourAgo = new Date();
        oneHourAgo.setHours(oneHourAgo.getHours() - 1);
        const querySnapshot = await db.collection("User")
            .where("userType", "==", "tester")
            //.where("lastSeen", ">", oneHourAgo)
            .get();
        const onlineTesters = querySnapshot.docs.filter(doc => {
            const lastSeen = doc.data().lastSeen;
            return lastSeen && lastSeen.toDate() > oneHourAgo;
        });

        return onlineTesters.length;
        //return 0;
        //return querySnapshot.size; 
    } catch (error) {
        console.error("Error fetching total online playtesters:", error);
        return 0; 
    }
}

/*Retrieve total number of developers that have logged in in the past 1 hour*/
async function getOnlineDevs() {
    try {
        const oneHourAgo = new Date();
        oneHourAgo.setHours(oneHourAgo.getHours() - 1);
        const querySnapshot = await db.collection("User")
            .where("userType", "==", "developer")
            //.where("lastSeen", "<", oneHourAgo)
            .get();
        const onlineDevs = querySnapshot.docs.filter(doc => {
            const lastSeen = doc.data().lastSeen;
            return lastSeen && lastSeen.toDate() > oneHourAgo;
        });

        return onlineDevs.length;
        //return querySnapshot.size;
        //return 0;
    } catch (error) {
        console.error("Error fetching total online developers:", error);
        return 0; 
    }
}

/*Retrieve the number of playtester profiles that are incomplete*/
async function getIncompleteTesters() {
    try {
        const querySnapshot = await db.collection("PlayTester").get();
        let incompleteCount = 0;

        for (const doc of querySnapshot.docs) {
            const isComplete = await PlayTesterUser.isPlayTesterProfileCompleted(doc.id);
            if (!isComplete) {
                incompleteCount++;
            }
        }
        return incompleteCount;
        //return 0;
    } catch (error) {
        console.error("Error fetching incomplete testers:", error);
        return 0;
    }
}

/*Retrieve the number of surveys that have not been approved by the admin*/
async function getUnapprovedSurveys() {
    try {
        const querySnapshot = await db.collection("Survey").where("status", "==", 3).get();
        return querySnapshot.size;
        //return 0;
    } catch (error) {
        console.error("Error fetching unapproved surveys:", error);
        return 0;
    }
}


export default {
    getTotalDevs,
    getTotalPlaytesters,
    getOnlineTesters,
    getOnlineDevs,
    getIncompleteTesters,
    getUnapprovedSurveys
}



// WEBPACK FOOTER //
// ./src/Firestore/GetStats.js